// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1h-kX","col":"Table_col__o4NmG","fulfillmentStatus":"Table_fulfillmentStatus__1OXaR","emailCol":"Table_emailCol__14ZEj"};